<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="DashboardFullfilment"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-3 mb-md-0">Proforma Invoice : Printed</h4>
            </div>
          </div>
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="search.pi_number"
                          type="text"
                          @keyup.enter="loadItems"
                          :placeholder="$t('piNumber')"
                        />
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="search.load_id"
                          @keyup.enter="loadItems"
                          type="text"
                          placeholder="Load Id"
                        />
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="row justify-content-start">
                        <div class="col-auto">
                          <button @click="loadItems" class="btn btn-primary">
                            {{$t('search_txt')}}
                          </button>
                        </div>
                        <div class="col-auto">
                          <button class="btn btn-primary" @click="resetFilter">
                            {{$t('resetFilter')}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <!--  
                                                @on-page-change="onPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange" 
                                            -->
                      <vue-good-table
                        title="list-order-ct"
                        mode="remote"
                        ref="vgtTable"
                        :select-options="{
                          enabled: true,
                          selectOnCheckboxOnly: true,
                          selectionText: $t('data_selected'),
                          clearSelectionText: $t('clear'),
                        }"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-selected-rows-change="selectionChanged"
                        :pagination-options="{
                          enabled: true,
                        }"
                        :rows="rows"
                        :columns="columns"
                      >
                        <div slot="selected-row-actions">
                          <button
                            class="btn btn-success btn-xs"
                            style="margin-right: 20px"
                            @click="downloadData"
                          >
                            <i class="mdi mdi-file-document"></i
                            >{{ $t("downloadData") }} .xlsx
                          </button>
                        </div>
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'actions'">
                            <button
                              type="button"
                              class="btn btn-primary btn-icon"
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Delete"
                              @click="deleteData(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-delete"
                                style="font-size: 16px"
                              ></i>
                            </button>
                          </span>
                          <span v-else-if="props.column.field == 'entries'">
                            <a
                              style="
                                color: #ab0635;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Detail Load Id"
                              @click.prevent="detailPi(props.row)"
                            >
                              {{ props.row.entries }}
                            </a>
                          </span>
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <modal-proformaInvoiceDetail
            :showModal="showModalPI"
            :data="this.detailData"
            @closeModal="closeMyModal"
          >
          </modal-proformaInvoiceDetail>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import ModalProformaInvoiceDetail from "@/components/modal/modalProformaInvoiceDetail.vue";

export default {
  name: "proformaInvoiceCreated",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-proformaInvoiceDetail": ModalProformaInvoiceDetail,
  },
  data() {
    return {
      closeBtn: true,
      isLoading: false,
      errors: [],
      proformaInvoiceNo: "",
      loadId: "",
      totalRecords: 0,
      showModalPI: false,
      rowsSelection: [],
      detailData: [],
      columns: [
        {
          label: this.$t("piNumber"),
          field: "pi_number",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By " + this.$t("piNumber"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Entries",
          field: "entries",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By " + this.$t("companyTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Total",
          field: "total",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By " + this.$t("companyTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
          formatFn: this.formatCurrency,
        },
        {
          label: this.$t("create_at_txt"),
          field: "created_at",
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd MMM yyyy h:mm:ss a", //'dd MMM yyyy',
          tdClass: 'text-left',
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By " + this.$t("create_at_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        },
      ],
      rows: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      search: {
        pi_number: "",
        load_id: "",
      },
    };
  },
  methods: {

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    downloadData(){
      this.$swal({
        icon: "warning",
        title: "Please Wait",
        text: "Don't Close This Page !!!",
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        didOpen: async () => {
          this.$swal.showLoading();

          let list = "";
          this.rowsSelection.forEach((item)=>{
            if(list == ''){
              list = list + item.proforma_invoice_header_id;
            }else{
              list = list + ","+item.proforma_invoice_header_id
            }            
          });
          const baseURI =
              this.$settings.endPointProformaInvoice +
              "v1/proforma-invoice/download-excel-print?proforma_invoice_header_id="+list;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name =
              "proforma_invoice_" +
              CurrentDate +
              ".xlsx";
            
            await this.$http
              .get(baseURI, { responseType: "blob" })
              .then((response) => {
                var fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                console.log(response.data);
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                return true;
              })
              .catch((error) => {
                console.log(error.response);
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
                return false;
              });
            this.$swal.close();

        },
      }).then(() => {
        this.$refs['vgtTable']. unselectAllInternal();
      });
    },
    closeMyModal() {
      this.showModalPI = false;
      this.loadItems();
    },
    detailPi(row) {
      this.detailData["method"] = "detail";
      this.detailData["data"] = row;
      this.showModalPI = true;
    },
    deleteData(index, data) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          const baseURI =
            this.$settings.endPointProformaInvoice +
            "v1/proforma-invoice/delete/" +
            data.proforma_invoice_header_id;

          this.$http
            .delete(baseURI)
            .then((response) => {
              if (response.data.status === 200) {
                this.success("Success");
                this.loadItems();
                return true;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                return false;
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              return false;
            });

        }
      });
    },
    loadItems() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/proforma-invoice/index";

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pi_number=${this.search.pi_number}&load_id=${this.search.load_id}&type=print`
        )
        .then((response) => {
          this.rows = [];
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.loading();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selectionChanged(ev) {
      this.rowsSelection = [];
      this.rowsSelection = ev.selectedRows;
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ProformaInvoiceController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    fade(type) {
      this.isLoading = type;
    },
    resetFilter() {
      this.search.pi_number = "";
      this.search.load_id = "";
      this.serverParams.page = 1;
      this.serverParams.per_page = 10;
      this.loadItems();
    },
  },
  mounted() {
    this.fetchIt();
    this.loadItems();
  },
};
</script>

<style></style>
